import { nextReduxWrapper } from '../../src/client/store/create-store';
import fetchAllProductData from '../../src/client/models/product/fetch-all-product-data';
import TaxPage from '../../src/client/pages/campaigns/tax-time';

export const getServerSideProps = nextReduxWrapper.getServerSideProps((store) => async () => {
  await fetchAllProductData(store.getState(), store.dispatch);
  return { props: {} };
});

export default TaxPage;
